import { useContext } from 'react';

import { PagePublishContext } from 'contexts/page-publish-dto/PagePublishContext';

export const usePagePublish = () => {
  const pagePublish = useContext(PagePublishContext);
  return pagePublish;
};
